import { cn } from "@/lib/utils"
import Link from "next/link"
import { Facebook } from "./facebook"
import { Ins } from "./ins"
import { Pin } from "./pin"
import { Tiktok } from "./tiktok"
import { X } from "./x"
import { Youtube } from "./youtube"

export const SocialLinks = ({
  product,
  className,
}: {
  product?: any
  className?: string
}) => {
  return (
    <div className={cn("grid grid-flow-col justify-start gap-xs", className)}>
      <Link
        target="_blank"
        rel="nofollow"
        href={
          product
            ? "http://www.facebook.com/sharer.php?u=" +
              globalThis.location.origin +
              "/" +
              product.url_key +
              ".html"
            : "https://www.facebook.com/kingsyardofficial"
        }
      >
        <Facebook className="h-[20px] w-[20px]" />
      </Link>

      <Link
        target="_blank"
        rel="nofollow"
        href={"https://www.tiktok.com/@kingsyard_official"}
      >
        <Tiktok className="h-[20px] w-[20px]" />
      </Link>

      <Link
        target="_blank"
        rel="nofollow"
        href={
          product
            ? "http://www.facebook.com/sharer.php?u=" +
              globalThis.location.origin +
              "/" +
              product.url_key +
              ".html"
            : "https://www.instagram.com/kingsyard_official/"
        }
      >
        <Ins className="h-[20px] w-[20px]" />
      </Link>

      <Link
        target="_blank"
        rel="nofollow"
        href={"https://www.youtube.com/@kingsyard_official/"}
      >
        <Youtube className="h-[20px] w-[20px]" />
      </Link>

      <Link
        target="_blank"
        rel="nofollow"
        href={
          product
            ? "http://pinterest.com/pin/create/button/?url=" +
              globalThis.location.origin +
              "/" +
              product.url_key +
              ".html&media=" +
              process.env.NEXT_PUBLIC_MAGENTO_BACKEND_URL +
              "media/catalog/product/" +
              product?.media_gallery_entries[0].file +
              "&description=" +
              product.name
            : "https://www.pinterest.com/Official_KingsYard/"
        }
      >
        <Pin className="h-[20px] w-[20px]" />
      </Link>

      <Link href={"https://x.com/Kingsyard_"} target="_blank" rel="nofollow">
        <X className="h-[20px] w-[20px]" />
      </Link>
    </div>
  )
}
